/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

const Model = (props) => {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/plane_normal.glb", "https://www.gstatic.com/draco/versioned/decoders/1.4.1/");
  const { actions } = useAnimations(animations, group);
  useEffect(() => {
    //Object.values(actions).forEach((v) => v && v.setDuration(5) && v.play());
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.Plane001.geometry}
        material={materials["Haus_hell.001"]}
      />
      <mesh
        geometry={nodes.Plane001_1.geometry}
        material={nodes.Plane001_1.material}
      />
      <mesh
        geometry={nodes.Plane001_2.geometry}
        material={materials["Anlage_aus.001"]}
      />
      <mesh
        geometry={nodes.Plane001_3.geometry}
        material={materials["Material.010"]}
      />
      <mesh
        geometry={nodes.Plane001_4.geometry}
        material={materials["Material.009"]}
      />
      <mesh
        geometry={nodes.Plane001_5.geometry}
        material={materials["Material.008"]}
      />
      <mesh
        geometry={nodes.Plane001_6.geometry}
        material={materials["Material.007"]}
      />
      <mesh
        geometry={nodes.Plane001_7.geometry}
        material={materials["Material.006"]}
      />
      <mesh
        geometry={nodes.Plane001_8.geometry}
        material={materials["HellBraun.001"]}
      />
      <mesh
        name="Propeller"
        geometry={nodes.Propeller.geometry}
        material={nodes.Propeller.material}
        position={[0.028503268957, 0.054187275469, -0.442353725433]}
      />
    </group>
  );
};

export default Model;
